import { useWrapAsync } from "@paroicms/front-app-log";
import { useState } from "react";
import { fetchTableForm } from "../../api/application/table-appendix";
import type { TableForm } from "../../api/infrastructure/table-appendix.formatter";
import { apiRequestWrapper } from "../../api/shared/http-client";

export default function useGetTableForm() {
  const [tableForm, setTableForm] = useState<TableForm[]>([]);
  const [loading, setLoading] = useState(false);
  const wrapAsync = useWrapAsync();

  const fetch = wrapAsync(
    async ({ referenceId, tableId }: { referenceId: number; tableId: number }) => {
      setLoading(true);
      await apiRequestWrapper(async () => {
        const result = await fetchTableForm({ referenceId, tableId });
        setTableForm(result);
      });
      setLoading(false);
    },
  );

  return { tableForm, loadingTableForm: loading, fetchTableForm: fetch };
}
